/*=========================================================================================
  File Name: moduleSettingsMutations.js
  Description: Mutations for the settings module.
==========================================================================================*/

export default {
  SET_TEMPLATE_TYPE(state, value) {
    if (typeof value !== 'number')
      throw new Error('Invalid Type - Mutation value parameter must be a number.')

    switch (value) {
      case 1: {
        state.template_type = ''
      } break;
      case 2: {
        state.template_type = '_2'
      } break;
      case 3: {
        state.template_type = '_3'
      } break;
      default: {
        throw new Error('Argument out of Range - Mutation value must be an integer in the range 1 to 3.')
      }
    }
  },
}
